import { Text, Tooltip } from "@fluentui/react-components";
import { IIconPermissionProps } from "./Model";
//import { IconPermissionWrapper } from "./Style";
import { EDeclineType } from "@/services/resource-service/entity/Enums";
import {
  RenderIconPermissionInfo,
  RenderIconPermissionRed,
  RenderIconPermissionRedFull,
} from "@/components/ui/Icons/IconsCustom";
import { useTranslation } from "react-i18next";
import { BuildRCAttribute } from "@/common/function/RCAttribute";
import { ContentPermissionWrapper } from "./Style";
import {
  ETextDescPermission,
  ETextDescPermissionRecurringAvailability,
  ETextPermission,
} from "@/common/entity/Enum";
import { TFunction } from "i18next";
import { ExchangeProperty, ResourceMeetingInfo } from "@/services";

export function priorityDeclineType(declines: ResourceMeetingInfo[], isRecurring?: boolean): EDeclineType {
  const declineArrayString: EDeclineType[] = declines.map(item => item.declineType).filter(type => !!type)
  if(isRecurring) {
    if(declineArrayString.includes(EDeclineType.NotPermissionToBooking)) {
      return EDeclineType.NotPermissionToBooking;
    } else if(declineArrayString.includes(EDeclineType.AllowRecurringMeeting)) {
      return EDeclineType.AllowRecurringMeeting;
    } else if(declineArrayString.includes(EDeclineType.BookingWindowInDay)) {
      return EDeclineType.BookingWindowInDay
    } else if(declineArrayString.includes(EDeclineType.MaximumDurationInMinutes)) {
      return EDeclineType.MaximumDurationInMinutes;
    } else if(declineArrayString.includes(EDeclineType.AllowConflict)) {
      return EDeclineType.AllowConflict
    } else if(declineArrayString.includes(EDeclineType.MinimumDurationInMinutes)) {
      return EDeclineType.MinimumDurationInMinutes
    } else {
      return declineArrayString[0]
    }
  } else {
    if(declineArrayString.includes(EDeclineType.NotPermissionToBooking)) {
      return EDeclineType.NotPermissionToBooking;
    } else if(declineArrayString.includes(EDeclineType.BookingWindowInDay)) {
      return EDeclineType.BookingWindowInDay
    } else if(declineArrayString.includes(EDeclineType.MaximumDurationInMinutes)) {
      return EDeclineType.MaximumDurationInMinutes;
    } else if(declineArrayString.includes(EDeclineType.AllowConflict)) {
      return EDeclineType.AllowConflict
    } else if(declineArrayString.includes(EDeclineType.MinimumDurationInMinutes)) {
      return EDeclineType.MinimumDurationInMinutes
    } else {
      return declineArrayString[0]
    }
  }
}

export const renderTextPermission = (type?: EDeclineType | null, isRecurring?: boolean) => {
  switch (type) {
    case EDeclineType.AllowConflict:
    case EDeclineType.BookingWindowInDay:
    case EDeclineType.MinimumDurationInMinutes:
    case EDeclineType.MaximumDurationInMinutes:
      return ETextPermission.AllowConflict;
    case EDeclineType.NotPermissionToBooking:
      return ETextPermission.NotPermissionToBooking;
    case EDeclineType.AllowRecurringMeeting:
      return ETextPermission.AllowRecurringMeeting;
    case EDeclineType.TentativeResource:
      return ETextPermission.TentativeResource;
    case EDeclineType.None:
      return ETextPermission.None;
    default:
      return "";
  }
};

export const renderTextDescPermission = (
  type: EDeclineType | null,
  t: TFunction,
  exchangeProperty?: ExchangeProperty,
  isRecurring?: boolean
) => {
  switch (type) {
    case EDeclineType.AllowConflict:
      return t(ETextDescPermission.AllowConflict);
    case EDeclineType.BookingWindowInDay:
      return t(ETextDescPermission.BookingWindowInDay, {
        day: exchangeProperty?.bookingWindowInDay,
      });
    case EDeclineType.MinimumDurationInMinutes:
      return t(ETextDescPermission.MinimumDurationInMinutes, {
        time: exchangeProperty?.minimumDurationInMinutes,
      });
    case EDeclineType.MaximumDurationInMinutes:
      return t(ETextDescPermission.MaximumDurationInMinutes, {
        time: exchangeProperty?.maximumDurationInMinutes,
      });
    case EDeclineType.NotPermissionToBooking:
      return t(ETextDescPermission.NotPermissionToBooking);
    case EDeclineType.AllowRecurringMeeting:
      return t(ETextDescPermission.AllowRecurringMeeting);
    case EDeclineType.None:
      return t(ETextDescPermission.None);
    default:
      return "";
  }
};

export const renderTextDescPermissionRecurringAvailability = (
  type: EDeclineType | null,
  t: TFunction,
  exchangeProperty?: ExchangeProperty
) => {
  switch (type) {
    case EDeclineType.AllowConflict:
      return t(ETextDescPermissionRecurringAvailability.AllowConflictRecurring);
    case EDeclineType.BookingWindowInDay:
      return t(ETextDescPermissionRecurringAvailability.BookingWindowInDay, {
        day: exchangeProperty?.bookingWindowInDay,
      });
    case EDeclineType.MinimumDurationInMinutes:
      return t(
        ETextDescPermissionRecurringAvailability.MinimumDurationInMinutes,
        {
          time: exchangeProperty?.minimumDurationInMinutes,
        }
      );
    case EDeclineType.MaximumDurationInMinutes:
      return t(
        ETextDescPermissionRecurringAvailability.MaximumDurationInMinutes,
        {
          time: exchangeProperty?.maximumDurationInMinutes,
        }
      );
    default:
      return "";
  }
};

const IconPermission = (props: IIconPermissionProps) => {
  const { t } = useTranslation();

  const renderContentPermission = (): JSX.Element | string | null => {
    const meetingDeclines = (props.permission?.meetingDeclines || []).filter(
      (item) => item.declineType !== EDeclineType.None
    );
    const declineType = meetingDeclines.length
      ? priorityDeclineType(meetingDeclines, props.isRecurring)
      : (props.permission?.meetingDeclines
      ? priorityDeclineType(props.permission?.meetingDeclines, props.isRecurring)
      : null);
    if (declineType) {
      switch (declineType) {
        case EDeclineType.AllowConflict:
          return (
            <ContentPermissionWrapper className="ContentPermissionWrapper">
              <Text>{t(renderTextPermission(EDeclineType.AllowConflict, props.isRecurring))}</Text>
            </ContentPermissionWrapper>
          );
        case EDeclineType.NotPermissionToBooking:
          return (
            <ContentPermissionWrapper className="ContentPermissionWrapper">
              <Text>{t("Booking policy")}:</Text>
              <br />
              <Text>
                {t(renderTextPermission(EDeclineType.NotPermissionToBooking, props.isRecurring))}
              </Text>
            </ContentPermissionWrapper>
          );
        case EDeclineType.AllowRecurringMeeting:
          return (
            <ContentPermissionWrapper className="ContentPermissionWrapper">
              <Text>{t("Booking policy")}:</Text>
              <br />
              <Text>
                {t(renderTextPermission(EDeclineType.AllowRecurringMeeting))}
              </Text>
            </ContentPermissionWrapper>
          );
        case EDeclineType.BookingWindowInDay:
          return (
            <ContentPermissionWrapper className="ContentPermissionWrapper">
              <Text>
                {t(renderTextPermission(EDeclineType.BookingWindowInDay))}
              </Text>
              <br />
              <Text>
                {t("Reason")}:{" "}
                {renderTextDescPermission(
                  EDeclineType.BookingWindowInDay,
                  t,
                  props.exchangeProperty,
                  props.isRecurring
                )}
              </Text>
            </ContentPermissionWrapper>
          );
        case EDeclineType.MinimumDurationInMinutes:
          return (
            <ContentPermissionWrapper className="ContentPermissionWrapper">
              <Text>
                {t(renderTextPermission(EDeclineType.MinimumDurationInMinutes))}
              </Text>
              <br />
              <Text>
                {t("Reason")}:{" "}
                {renderTextDescPermission(
                  EDeclineType.MinimumDurationInMinutes,
                  t,
                  props.exchangeProperty,
                  props.isRecurring
                )}
              </Text>
            </ContentPermissionWrapper>
          );

        case EDeclineType.MaximumDurationInMinutes:
          return (
            <ContentPermissionWrapper className="ContentPermissionWrapper">
              <Text>
                {t(renderTextPermission(EDeclineType.MaximumDurationInMinutes))}
              </Text>
              <br />
              <Text>
                {t("Reason")}:{" "}
                {renderTextDescPermission(
                  EDeclineType.MaximumDurationInMinutes,
                  t,
                  props.exchangeProperty,
                  props.isRecurring
                )}
              </Text>
            </ContentPermissionWrapper>
          );
        default:
          return null;
      }
    }
    return null;
  };

  const renderContentPermissionAvailability = ():
    | JSX.Element
    | string
    | null => {
    const meetingDeclines = (props.permission?.meetingDeclines || []).filter(
      (item) => item.declineType !== EDeclineType.None
    );
    const declineType = meetingDeclines.length
      ? priorityDeclineType(meetingDeclines, props.isRecurring)
      : props.permission?.meetingDeclines
      ? priorityDeclineType(
          props.permission?.meetingDeclines,
          props.isRecurring
        )
      : null;
    if (declineType) {
      switch (declineType) {
        case EDeclineType.AllowConflict:
          return (
            <ContentPermissionWrapper className="ContentPermissionWrapper">
              <Text>{t("Booking policy")}</Text>
              <br />
              <Text>
                {t(
                  renderTextDescPermissionRecurringAvailability(
                    EDeclineType.AllowConflict,
                    t,
                    props.exchangeProperty
                  )
                )}
              </Text>
            </ContentPermissionWrapper>
          );
        case EDeclineType.AllowRecurringMeeting:
          return (
            <ContentPermissionWrapper className="ContentPermissionWrapper">
              <Text>{t("Booking policy")}</Text>
              <br />
              <Text>
                {t(
                  renderTextDescPermissionRecurringAvailability(
                    EDeclineType.AllowRecurringMeeting,
                    t,
                    props.exchangeProperty
                  )
                )}
              </Text>
            </ContentPermissionWrapper>
          );
        case EDeclineType.BookingWindowInDay:
          return (
            <ContentPermissionWrapper className="ContentPermissionWrapper">
              <Text>{t("Booking policy")}</Text>
              <br />
              <Text>
                {renderTextDescPermissionRecurringAvailability(
                  EDeclineType.BookingWindowInDay,
                  t,
                  props.exchangeProperty
                )}
              </Text>
            </ContentPermissionWrapper>
          );
        case EDeclineType.MinimumDurationInMinutes:
          return (
            <ContentPermissionWrapper className="ContentPermissionWrapper">
              <Text>{t("Booking policy")}</Text>
              <br />
              <Text>
                {renderTextDescPermissionRecurringAvailability(
                  EDeclineType.MinimumDurationInMinutes,
                  t,
                  props.exchangeProperty
                )}
              </Text>
            </ContentPermissionWrapper>
          );

        case EDeclineType.MaximumDurationInMinutes:
          return (
            <ContentPermissionWrapper className="ContentPermissionWrapper">
              <Text>{t("Booking policy")}</Text>
              <br />
              <Text>
                {renderTextDescPermissionRecurringAvailability(
                  EDeclineType.MaximumDurationInMinutes,
                  t,
                  props.exchangeProperty
                )}
              </Text>
            </ContentPermissionWrapper>
          );
        default:
          return null;
      }
    }
    return null;
  };

  const renderIconPermission = (): JSX.Element | null => {
    const meetingDeclines = (props.permission?.meetingDeclines || []).filter(
      (item) => item.declineType !== EDeclineType.None
    );
    const declineType = meetingDeclines.length
      ? priorityDeclineType(meetingDeclines, props.isRecurring)
      : (props.permission?.meetingDeclines
        ? priorityDeclineType(props.permission?.meetingDeclines, props.isRecurring)
        : null);
    if (declineType) {
      switch (declineType) {
        case EDeclineType.AllowConflict:
          return props.isRecurring &&
            props.permission.isAcceptSelectRecurring(
              props.quantityMeetingInfo || 0
            ) ? (
            <Tooltip
              content={renderContentPermissionAvailability() || ""}
              relationship="label"
            >
              <div {...BuildRCAttribute(`resource_item.permission`)}>
                <RenderIconPermissionInfo />
              </div>
            </Tooltip>
          ) : (
            <Tooltip
              content={renderContentPermission() || ""}
              relationship="label"
            >
              <div {...BuildRCAttribute(`resource_item.permission`)}>
                <RenderIconPermissionRedFull />
              </div>
            </Tooltip>
          );
        case EDeclineType.NotPermissionToBooking:
          return (
            <Tooltip
              content={renderContentPermission() || ""}
              relationship="label"
            >
              <div {...BuildRCAttribute(`resource_item.permission`)}>
                <RenderIconPermissionRed />
              </div>
            </Tooltip>
          );
        case EDeclineType.AllowRecurringMeeting:
          return props.isRecurring &&
            props.permission.isAcceptSelectRecurring(
              props.quantityMeetingInfo || 0
            ) ? (
            <Tooltip
              content={renderContentPermissionAvailability() || ""}
              relationship="label"
            >
              <div {...BuildRCAttribute(`resource_item.permission`)}>
                <RenderIconPermissionInfo />
              </div>
            </Tooltip>
          ) : (
            <Tooltip
              content={renderContentPermission() || ""}
              relationship="label"
            >
              <div {...BuildRCAttribute(`resource_item.permission`)}>
                <RenderIconPermissionRedFull />
              </div>
            </Tooltip>
          );
        case EDeclineType.BookingWindowInDay:
          return props.isRecurring &&
            props.permission.isAcceptSelectRecurring(
              props.quantityMeetingInfo || 0
            ) ? (
            <Tooltip
              content={renderContentPermissionAvailability() || ""}
              relationship="label"
            >
              <div {...BuildRCAttribute(`resource_item.permission`)}>
                <RenderIconPermissionInfo />
              </div>
            </Tooltip>
          ) : (
            <Tooltip
              content={renderContentPermission() || ""}
              relationship="label"
            >
              <div {...BuildRCAttribute(`resource_item.permission`)}>
                <RenderIconPermissionRedFull />
              </div>
            </Tooltip>
          );
        case EDeclineType.MinimumDurationInMinutes:
          return props.isRecurring &&
            props.permission.isAcceptSelectRecurring(
              props.quantityMeetingInfo || 0
            ) ? (
            <Tooltip
              content={renderContentPermissionAvailability() || ""}
              relationship="label"
            >
              <div {...BuildRCAttribute(`resource_item.permission`)}>
                <RenderIconPermissionInfo />
              </div>
            </Tooltip>
          ) : (
            <Tooltip
              content={renderContentPermission() || ""}
              relationship="label"
            >
              <div {...BuildRCAttribute(`resource_item.permission`)}>
                <RenderIconPermissionRedFull />
              </div>
            </Tooltip>
          );

        case EDeclineType.MaximumDurationInMinutes:
          return props.isRecurring &&
            props.permission.isAcceptSelectRecurring(
              props.quantityMeetingInfo || 0
            ) ? (
            <Tooltip
              content={renderContentPermissionAvailability() || ""}
              relationship="label"
            >
              <div {...BuildRCAttribute(`resource_item.permission`)}>
                <RenderIconPermissionInfo />
              </div>
            </Tooltip>
          ) : (
            <Tooltip
              content={renderContentPermission() || ""}
              relationship="label"
            >
              <div {...BuildRCAttribute(`resource_item.permission`)}>
                <RenderIconPermissionRedFull />
              </div>
            </Tooltip>
          );
        default:
          return null;
      }
    }
    return null;
  };

  return <>{renderIconPermission()}</>;
};

export default IconPermission;
